export const useStyles = () => {
    return ({
        evidence: {
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            justifyContent: 'space-between',
            height: '100%'
        },
        mainContainer: {
            display: 'flex',
            flexDirection: 'column',
            height: '90vh',
        },
        bodyContainer: {
            flex: 1,
            overflow: 'auto',
            scrollbarWidth: 'none',
            padding: '0px 2px'
        },
    })
}